export const Websites = [
  {
    continent: "Asia",
    countries: [
      {
        Country: "Afghanistan",
        Company: "Afghan Post",
        Website: "http://www.afghanpost.gov.af/",
        Status: "Active",
      },
      {
        Country: "Azerbaijan",
        Company: "Azərpoçt",
        Website: "http://www.azerpost.az/",
        Status: "Active",
      },
      {
        Country: "Bahrain",
        Company: "Bahrain Post",
        Website:
          "http://www.customs.gov.bh/page.php?SID=WTBkR2JscFVNRE5PUTFwMFVGUkpiV015TURsT2FsRTk%253D",
        Status: "Active",
      },
      {
        Country: "Bangladesh",
        Company: "Bangladesh Post Office",
        Website:
          "http://www.atn-news.com/post-code-bd/post-code-bangladesh-post-code-bd/",
        Status: "Active",
      },
      {
        Country: "Bhutan",
        Company: "Bhutan Postal Corporation",
        Website: "http://www.bhutanpost.bt/",
        Status: "Active",
      },
      {
        Country: "Brunei",
        Company: "Brunei Postal Services Department",
        Website: "http://www.post.gov.bn/",
        Status: "Active",
      },
      {
        Country: "Cambodia",
        Company: "Cambodian Post",
        Website: "http://www.cambodiapost.com.kh/",
        Status: "Active",
      },
      {
        Country: "China",
        Company: "China Post",
        Website: "http://www.chinapost.com.cn/",
        Status: "Active",
      },
      {
        Country: "Hong Kong",
        Company: "Hongkong Post",
        Website: "https://www.hongkongpost.hk/",
        Status: "Active",
      },
      {
        Country: "India",
        Company: "India Post",
        Website: "http://www.indiapost.gov.in/",
        Status: "Active",
      },
      {
        Country: "Indonesia",
        Company: "Pos Indonesia",
        Website: "http://www.posindonesia.co.id/",
        Status: "Active",
      },
      {
        Country: "Iran",
        Company: "IRI Post",
        Website: "http://www.post.ir/",
        Status: "Active",
      },
      {
        Country: "Iraq",
        Company: "Iraqi Telecommunications and Post Company",
        Website: "http://www.iraqipost.net/",
        Status: "Active",
      },
      {
        Country: "Japan",
        Company: "Japan Post Holdings",
        Website: "http://www.japanpost.jp/",
        Status: "Active",
      },
      {
        Country: "Jordan",
        Company: "Jordan Post Company",
        Website: "http://www.jordanpost.com.jo/",
        Status: "Active",
      },
      {
        Country: "Kazakhstan",
        Company: "Kazpost",
        Website: "http://www.kazpost.kz/",
        Status: "Active",
      },
      {
        Country: "Kuwait",
        Company: "Ministry of Communications (Kuwait)",
        Website: "http://www.moc.gov.kw/post1/index.htm",
        Status: "Active",
      },
      {
        Country: "Kyrgyzstan",
        Company: "Kyrgyz Express Post",
        Website: "https://www.kep.kg//",
        Status: "Active",
      },
      {
        Country: "Lebanon",
        Company: "LibanPost",
        Website: "https://www.libanpost.com/",
        Status: "Active",
      },
      {
        Country: "Macau",
        Company: "Correios de Macau",
        Website: "http://www.macaupost.gov.mo/",
        Status: "Active",
      },
      {
        Country: "Malaysia",
        Company: "Pos Malaysia",
        Website: "http://www.pos.com.my/",
        Status: "Active",
      },
      {
        Country: "Maldives",
        Company: "Maldives Post",
        Website: "http://www.maldivespost.com/",
        Status: "Active",
      },
      {
        Country: "Mongolia",
        Company: "Mongol Post",
        Website: "http://www.mongolpost.mn/",
        Status: "Active",
      },
      {
        Country: "Myanmar",
        Company: "Myanmar Post and Telecommunications Department",
        Website:
          "https://web.archive.org/web/20090929004113/http://www.mcpt.gov.mm/ptd/index.htm",
        Status: "Active",
      },
      {
        Country: "Nepal",
        Company: "Nepal Post",
        Website: "http://www.nepalpost.gov.np/",
        Status: "Active",
      },
      {
        Country: "North Korea",
        Company: "Korea Post and Telecommunications Corporation",
        Website: "post.com.kp",
        Status: "Active",
      },
      {
        Country: "Oman",
        Company: "Oman Post",
        Website: "http://www.omanpost.om/",
        Status: "Active",
      },
      {
        Country: "Pakistan",
        Company: "Pakistan Post",
        Website: "http://www.pakpost.gov.pk/",
        Status: "Active",
      },
      {
        Country: "Palestine",
        Company: "Palestine Post",
        Website: "http://www.palpost.ps/",
        Status: "Active",
      },
      {
        Country: "Philippines",
        Company: "PHLPost",
        Website: "http://www.philpost.gov.ph/",
        Status: "Active",
      },
      {
        Country: "Qatar",
        Company: "Qatar Post",
        Website: "http://qatarpost.qa/",
        Status: "Active",
      },
      {
        Country: "Saudi Arabia",
        Company: "Saudi Post",
        Website: "https://splonline.com.sa/",
        Status: "Active",
      },
      {
        Country: "Singapore",
        Company: "Singapore Post",
        Website: "http://www.singpost.com",
        Status: "Active",
      },
      {
        Country: "South Korea",
        Company: "Korea Post",
        Website: "http://www.koreapost.go.kr/",
        Status: "Active",
      },
      {
        Country: "Sri Lanka",
        Company: "Sri Lanka Post",
        Website: "http://www.slpost.gov.lk/",
        Status: "Active",
      },
      {
        Country: "Syria",
        Company: "Syria Post",
        Website: "http://www.syrianpost.gov.sy/",
        Status: "Active",
      },
      {
        Country: "Taiwan",
        Company: "Chunghwa Post",
        Website: "http://www.post.gov.tw/",
        Status: "Active",
      },
      {
        Country: "Thailand",
        Company: "Thailand Post",
        Website: "http://www.thailandpost.com/",
        Status: "Active",
      },
      {
        Country: "Turkmenistan",
        Company: "Turkmenpochta",
        Website: "http://www.turkmenpost.gov.tm/",
        Status: "Active",
      },
      {
        Country: "United Arab Emirates",
        Company: "Empost",
        Website: "http://www.empostuae.com",
        Status: "Active",
      },
      {
        Country: "Uzbekistan",
        Company: "O′zbekiston Pochtasi",
        Website: "http://www.pochta.uz",
        Status: "Active",
      },
      {
        Country: "Vietnam",
        Company: "Vietnam Post Corporation",
        Website: "http://www.vnpost.vn/",
        Status: "Active",
      },
      {
        Country: "Yemen",
        Company: "Yemen Post",
        Website: "http://www.post.ye/",
        Status: "Active",
      },
    ],
  },
  {
    continent: "America",
    countries: [
      {
        Country: "Argentina",
        Company: "Correo Argentino",
        Website: "http://www.correoargentino.com.ar/",
        Status: "State-owned enterprise",
      },
      {
        Country: "Aruba",
        Company: "Post Aruba",
        Website: "http://www.postaruba.com/",
        Status: null,
      },
      {
        Country: "Barbados",
        Company: "Barbados Postal Service",
        Website: "https://bps.gov.bb/",
        Status: "State-owned enterprise",
      },
      {
        Country: "Belize",
        Company: "Belize Postal Service",
        Website: null,
        Status: null,
      },
      {
        Country: "Bolivia",
        Company: "Empresa de Correos de Bolivia",
        Website: "http://www.correosbolivia.com/",
        Status: null,
      },
      {
        Country: "Brazil",
        Company: "Correios",
        Website: "http://www.correios.com.br/",
        Status: "Government agency",
      },
      {
        Country: "Canada",
        Company: "Canada Post",
        Website: "http://www.canadapost.ca/segment-e.asp",
        Status: "Crown corporation",
      },
      {
        Country: "Caribbean Netherlands",
        Company: "Flamingo Express Dutch Caribbean",
        Website: "http://www.fxdc-post.com/",
        Status: null,
      },
      {
        Country: "Chile",
        Company: "Correos de Chile",
        Website: "http://www.correos.cl/",
        Status: "State-owned enterprise",
      },
      {
        Country: "Colombia",
        Company: "Servicios Postales Nacionales (4-72)",
        Website: "http://www.4-72.com.co/",
        Status: null,
      },
      {
        Country: "Costa Rica",
        Company: "Correos de Costa Rica",
        Website: "http://www.correos.go.cr/",
        Status: null,
      },
      {
        Country: "Cuba",
        Company: "Correos de Cuba",
        Website: "http://www.correos.cu/",
        Status: null,
      },
      {
        Country: "Curaçao",
        Company: "Cpost International",
        Website: "https://www.cpostinternational.com/",
        Status: null,
      },
      {
        Country: "Dominica",
        Company: "General Post Office",
        Website: "http://publicworks.gov.dm/",
        Status: null,
      },
      {
        Country: "Dominican Republic",
        Company: "Dominican Postal Institute",
        Website: "http://www.inposdom.gob.do/",
        Status: null,
      },
      {
        Country: "Ecuador",
        Company: "Correos del Ecuador",
        Website: "https://www.serviciopostal.gob.ec/",
        Status: null,
      },
      {
        Country: "El Salvador",
        Company: "Correos de El Salvador",
        Website:
          "https://web.archive.org/web/20091004224712/http://www.correos.gob.sv/",
        Status: null,
      },
      {
        Country: "Guyana",
        Company: "Guyana Post Office Corporation",
        Website: "http://guypost.gy/gpoc/",
        Status: null,
      },
      {
        Country: "Haiti",
        Company: "LaPoste Haiti",
        Website: "https://laposte.gouv.ht/",
        Status: null,
      },
      {
        Country: "Honduras",
        Company: "Honducor",
        Website: "http://www.honducor.gob.hn/",
        Status: null,
      },
      {
        Country: "Jamaica",
        Company: "Postal Corporation of Jamaica",
        Website: "http://www.jamaicapost.gov.jm/",
        Status: null,
      },
      {
        Country: "Mexico",
        Company: "Correos de México",
        Website: "http://www.sepomex.gob.mx/",
        Status: null,
      },
      {
        Country: "Nicaragua",
        Company: "Correos de Nicaragua",
        Website: "http://www.correos.gob.ni/",
        Status: null,
      },
      {
        Country: "Panama",
        Company: "Correos de Panamá",
        Website: "http://www.correospanama.gob.pa/",
        Status: null,
      },
      {
        Country: "Paraguay",
        Company: "Correo Nacional Paraguayo",
        Website: "http://www.correoparaguayo.gov.py/",
        Status: null,
      },
      {
        Country: "Peru",
        Company: "Serpost",
        Website: "http://www.serpost.com.pe/",
        Status: null,
      },
      {
        Country: "Saint Kitts and Nevis",
        Company: "St. Kitts & Nevis Postal Services",
        Website: "https://post.kn/",
        Status: null,
      },
      {
        Country: "Saint Lucia",
        Company: "Saint Lucia Postal Service",
        Website: "http://stluciapostal.com/",
        Status: null,
      },

      {
        Country: "Sint Maarten",
        Company: "Postal Services St. Maarten",
        Website: "http://www.pssnv.sx",
        Status: null,
      },
      {
        Country: "Suriname",
        Company: "Surpost",
        Website: "http://www.surpost.com/",
        Status: null,
      },
      {
        Country: "Trinidad and Tobago",
        Company: "TTPost",
        Website: "http://www.ttpost.net/",
        Status: null,
      },
      {
        Country: "United States",
        Company: "United States Postal Service",
        Website: "http://www.usps.com/",
        Status: "Independent agency",
      },
      {
        Country: "Uruguay",
        Company: "Correo Uruguayo",
        Website: "https://www.correo.com.uy/",
        Status: null,
      },
      {
        Country: "Venezuela",
        Company: "IPOSTEL",
        Website: "https://www.ipostel.gob.ve/",
        Status: null,
      },
    ],
  },
  {
    continent: "Africa",
    countries: [
      {
        Country: "Algeria",
        Company: "Poste Algérie",
        Website: "http://www.poste.dz/",
        Status: null,
      },
      {
        Country: "Angola",
        Company: "Correios de Angola",
        Website: "http://www.correiosdeangola.ao/",
        Status: null,
      },
      {
        Country: "Benin",
        Company: "La Poste du Bénin",
        Website: "http://www.laposte.bj/",
        Status: null,
      },
      {
        Country: "Botswana",
        Company: "BotswanaPost",
        Website: "http://www.botspost.co.bw/",
        Status: null,
      },
      {
        Country: "Burkina Faso",
        Company: "SONAPOST",
        Website: "http://www.sonapost.bf/",
        Status: null,
      },
      {
        Country: "Burundi",
        Company: "Régie Nationale des Postes",
        Website:
          "https://web.archive.org/web/20101027000421/http://www.poste.bi/",
        Status: null,
      },
      {
        Country: "Cameroon",
        Company: "CAMPOST",
        Website: "http://www.campostonline.com/",
        Status: null,
      },
      {
        Country: "Cape Verde",
        Company: "Correios de Cabo Verde",
        Website: "http://www.correios.cv/",
        Status: null,
      },
      {
        Country: "Central African Republic",
        Company:
          "Direction des services postaux de l'Office National des Postes et de l'Épargne",
        Website: "http://laposte.cf",
        Status: null,
      },
      {
        Country: "Chad",
        Company: "Société tchadienne des postes et de l'épargne",
        Website: "http://laposte.td/",
        Status: null,
      },
      {
        Country: "Côte d'Ivoire",
        Company: "La Poste (Côte d'Ivoire)",
        Website: "http://www.laposte.ci/bureau.php",
        Status: null,
      },
      {
        Country: "Congo",
        Company: "Congolese Posts and Telecommunications Corporation",
        Website: "https://scpt.cd/",
        Status: null,
      },
      {
        Country: "Egypt",
        Company: "Egypt Post",
        Website: "http://www.egyptpost.org",
        Status: null,
      },
      {
        Country: "Eritrea",
        Company: "Eritrean Postal Service",
        Website: "http://www.eripostal.com/",
        Status: null,
      },
      {
        Country: "Ethiopia",
        Company: "Ethiopian Postal Service",
        Website: "http://www.ethiopostal.com/",
        Status: null,
      },
      {
        Country: "Gabon",
        Company: "Gabon Poste",
        Website:
          "https://web.archive.org/web/20160304044307/http://www.laposte.ga/",
        Status: null,
      },
      {
        Country: "The Gambia",
        Company: "Gambia Postal Services Corporation",
        Website:
          "https://web.archive.org/web/20181107112341/http://www.gampost.gm/",
        Status: null,
      },
      {
        Country: "Ghana",
        Company: "Ghana Post",
        Website: "https://ghanapost.com.gh/",
        Status: null,
      },
      {
        Country: "Guinea",
        Company: "Office de la poste guinéenne",
        Website: null,
        Status: null,
      },
      {
        Country: "Guinea-Bissau",
        Company: "Correios da Guiné-Bissau",
        Website: null,
        Status: null,
      },
      {
        Country: "Kenya",
        Company: "Postal Corporation of Kenya",
        Website: "http://www.posta.co.ke/",
        Status: null,
      },
      {
        Country: "Lesotho",
        Company: "Lesotho Post",
        Website:
          "https://web.archive.org/web/20150322212818/http://www.lesothopost.org.ls/",
        Status: null,
      },
      {
        Country: "Liberia",
        Company: "Ministry of Posts and Telecommunications (Liberia)",
        Website: "http://www.mopt.gov.lr/",
        Status: null,
      },
      {
        Country: "Libya",
        Company: "General Posts and Telecommunications Company",
        Website: "http://libyapost.ly/en/",
        Status: null,
      },
      {
        Country: "Madagascar",
        Company: "Paositra Malagasy",
        Website: "http://www.paositra.mg/",
        Status: null,
      },
      {
        Country: "Malawi",
        Company: "Malawi Posts Corporation",
        Website: "http://www.malawiposts.com/",
        Status: null,
      },
      {
        Country: "Mali",
        Company: "Office national des postes du Mali",
        Website: "http://www.laposte.ml/",
        Status: null,
      },
      {
        Country: "Mauritania",
        Company: "La Société Mauritanienne des Postes",
        Website:
          "https://web.archive.org/web/20010520163306/http://www.mauripost.mr/",
        Status: null,
      },
      {
        Country: "Mauritius",
        Company: "Mauritius Post",
        Website: "http://www.mauritiuspost.mu/",
        Status: null,
      },
      {
        Country: "Morocco",
        Company: "Poste Maroc",
        Website: "http://www.poste.ma/",
        Status: null,
      },
      {
        Country: "Mozambique",
        Company: "Correios de Moçambique",
        Website: "http://www.correios.co.mz/",
        Status: null,
      },
      {
        Country: "Namibia",
        Company: "NamPost",
        Website: "http://www.nampost.com.na/",
        Status: null,
      },
      {
        Country: "Niger",
        Company: "Niger Poste",
        Website: "http://www.nigerposte.net/",
        Status: null,
      },
      {
        Country: "Nigeria",
        Company: "Nigerian Postal Service",
        Website: "http://www.nipost.gov.ng/",
        Status: null,
      },

      {
        Country: "Rwanda",
        Company: "National Post Office",
        Website: "http://i-posita.rw/",
        Status: null,
      },
      {
        Country: "Senegal",
        Company: "La Poste Senegal",
        Website: "http://www.laposte.sn/",
        Status: null,
      },
      {
        Country: "Seychelles",
        Company: "Seychelles Postal Service",
        Website: "http://www.seychellespost.gov.sc/",
        Status: null,
      },
      {
        Country: "Sierra Leone",
        Company: "SALPOST",
        Website:
          "https://web.archive.org/web/20120127035345/http://www.salpost.sl/",
        Status: null,
      },
      {
        Country: "Somalia",
        Company: "Somali Postal Service",
        Website: "http://mipt.gov.so/",
        Status: null,
      },
      {
        Country: "South Africa",
        Company: "South African Post Office",
        Website: "https://www.postoffice.co.za/",
        Status: null,
      },
      {
        Country: "South Sudan",
        Company: "Minister of Telecommunication and Postal Services",
        Website:
          "https://web.archive.org/web/20120915004829/http://www.motps.goss.org/",
        Status: null,
      },
      {
        Country: "Sudan",
        Company: "Sudapost",
        Website: "http://sudapost.sd/index.php/en/home",
        Status: null,
      },
      {
        Country: "Swaziland",
        Company: "Swaziland Posts and Telecommunications",
        Website: "http://www.sptc.co.sz/",
        Status: null,
      },
      {
        Country: "Tanzania",
        Company: "Tanzania Posts Corporation",
        Website: "http://www.posta.co.tz/",
        Status: null,
      },
      {
        Country: "Togo",
        Company: "La Poste du Togo",
        Website: "http://www.laposte.tg/",
        Status: null,
      },
      {
        Country: "Tunisia",
        Company: "La Poste Tunisienne",
        Website: "http://www.poste.tn/",
        Status: null,
      },
      {
        Country: "Uganda",
        Company: "Posta Uganda",
        Website: "http://www.ugapost.co.ug/",
        Status: null,
      },
      {
        Country: "Zambia",
        Company: "ZamPost",
        Website: "http://www.zampost.com.zm/",
        Status: null,
      },
      {
        Country: "Zimbabwe",
        Company: "ZimPost",
        Website: "http://www.zimpost.co.zw/",
        Status: null,
      },
    ],
  },
  {
    continent: "Europe",
    countries: [
      {
        Country: "Åland (Finland)",
        Company: "Posten Åland",
        Website: "http://www.alandpost.ax/",
        Status: null,
      },
      {
        Country: "Albania",
        Company: "Posta Shqiptare",
        Website: "http://www.postashqiptare.al/",
        Status: null,
      },
      {
        Country: "Armenia",
        Company: "HayPost",
        Website: "http://www.haypost.am/",
        Status: null,
      },
      {
        Country: "Austria",
        Company: "Österreichische Post",
        Website: "http://www.post.at/",
        Status: null,
      },
      {
        Country: "Belarus",
        Company: "Belposhta",
        Website: "http://www.belpost.by/",
        Status: null,
      },
      {
        Country: "Belgium",
        Company: "Bpost",
        Website: "https://www.bpost.be/",
        Status: null,
      },
      {
        Country: "Bosnia and Herzegovina",
        Company: "Hrvatska Pošta Mostar",
        Website: "http://www.post.ba/",
        Status: null,
      },

      {
        Country: "Bulgaria",
        Company: "Bulgarian Posts",
        Website: "http://www.bgpost.bg/",
        Status: null,
      },
      {
        Country: "Croatia",
        Company: "Hrvatska pošta",
        Website: "http://www.posta.hr/",
        Status: null,
      },
      {
        Country: "Cyprus",
        Company: "Cyprus Postal Services",
        Website: "https://www.cypruspost.post/en/home",
        Status: null,
      },
      {
        Country: "Czech Republic",
        Company: "Česká pošta",
        Website: "http://www.cpost.cz/",
        Status: null,
      },
      {
        Country: "Denmark",
        Company: "Post Danmark",
        Website: "http://www.postdanmark.dk/",
        Status: null,
      },
      {
        Country: "Estonia",
        Company: "Omniva",
        Website: "http://www.omniva.ee/",
        Status: null,
      },
      {
        Country: "Faroe Islands",
        Company: "Posta (company)",
        Website: "http://www.posta.fo/",
        Status: null,
      },
      {
        Country: "Finland",
        Company: "Posti Group",
        Website: "http://www.posti.fi/",
        Status: null,
      },
      {
        Country: "France",
        Company: "La Poste",
        Website: "http://www.laposte.fr/",
        Status: null,
      },
      {
        Country: "Georgia",
        Company: "Georgian Post",
        Website: "http://www.georgianpost.ge/",
        Status: null,
      },
      {
        Country: "Germany",
        Company: "Deutsche Post",
        Website: "http://www.deutschepost.de/",
        Status: "Aktiengesellschaft",
      },
      {
        Country: "Gibraltar",
        Company: "Royal Gibraltar Post Office",
        Website:
          "https://web.archive.org/web/20120420064148/http://www.gibraltar.gov.gi/postal-a-philatelic",
        Status: null,
      },
      {
        Country: "Greece",
        Company: "Hellenic Post",
        Website: "http://www.elta.gr/",
        Status: null,
      },
      {
        Country: "Greenland",
        Company: "Post Greenland",
        Website: "http://www.post.gl/",
        Status: null,
      },
      {
        Country: "Guernsey",
        Company: "Guernsey Post",
        Website: "http://www.guernseypost.com/",
        Status: null,
      },
      {
        Country: "Hungary",
        Company: "Magyar Posta",
        Website: "http://www.posta.hu/",
        Status: null,
      },
      {
        Country: "Iceland",
        Company: "Íslandspóstur",
        Website: "http://www.postur.is/",
        Status: null,
      },
      {
        Country: "Ireland",
        Company: "An Post",
        Website: "http://www.anpost.ie/",
        Status: null,
      },
      {
        Country: "Isle of Man",
        Company: "Isle of Man Post Office",
        Website:
          "https://web.archive.org/web/20040314205327/http://www.gov.im/post/",
        Status: null,
      },
      {
        Country: "Italy",
        Company: "Poste italiane",
        Website: "http://www.poste.it/",
        Status: null,
      },
      {
        Country: "Jersey (UK)",
        Company: "Jersey Post",
        Website: "http://www.jerseypost.com/",
        Status: null,
      },
      {
        Country: "Kosovo",
        Company: "Posta e Kosovës",
        Website:
          "https://web.archive.org/web/20181231194057/http://www.postakosoves.com/?page=2,1",
        Status: null,
      },
      {
        Country: "Latvia",
        Company: "Latvijas Pasts",
        Website: "http://www.pasts.lv/",
        Status: null,
      },
      {
        Country: "Liechtenstein",
        Company: "Liechtensteinische Post",
        Website: "http://www.post.li/",
        Status: null,
      },
      {
        Country: "Lithuania",
        Company: "Lietuvos paštas",
        Website: "http://www.post.lt/",
        Status: null,
      },
      {
        Country: "Luxembourg",
        Company: "Post Luxembourg",
        Website: "http://www.post.lu/",
        Status: null,
      },
      {
        Country: "Malta",
        Company: "MaltaPost",
        Website: "http://www.maltapost.com/",
        Status: null,
      },
      {
        Country: "Moldova",
        Company: "Poșta Moldovei",
        Website: "http://www.posta.md/",
        Status: null,
      },
      {
        Country: "Monaco",
        Company: "La Poste Monaco",
        Website: "http://www.lapostemonaco.mc/",
        Status: null,
      },
      {
        Country: "Montenegro",
        Company: "Pošta Crne Gore",
        Website: "http://www.postacg.me/",
        Status: null,
      },
      {
        Country: "Netherlands",
        Company: "PostNL",
        Website: "http://www.postnl.nl/",
        Status: null,
      },
      {
        Country: "North Macedonia",
        Company: "North Macedonia Post",
        Website: "http://www.posta.com.mk/",
        Status: null,
      },
      {
        Country: "Norway",
        Company: "Posten Norge",
        Website: "http://www.posten.no/",
        Status: null,
      },
      {
        Country: "Poland",
        Company: "Poczta Polska",
        Website: "http://www.poczta-polska.pl/",
        Status: null,
      },
      {
        Country: "Portugal",
        Company: "Correios de Portugal",
        Website: "http://www.ctt.pt/",
        Status: null,
      },
      {
        Country: "Romania",
        Company: "Poșta Română",
        Website: "http://www.posta-romana.ro/",
        Status: null,
      },
      {
        Country: "Russia",
        Company: "Russian Post",
        Website: "http://www.pochta.ru/",
        Status: null,
      },
      {
        Country: "San Marino",
        Company: "Poste San Marino",
        Website: "https://www.poste.sm/",
        Status: null,
      },
      {
        Country: "Serbia",
        Company: "Pošta Srbije",
        Website: "http://www.posta.rs/",
        Status: null,
      },
      {
        Country: "Slovakia",
        Company: "Slovenská pošta",
        Website: "http://www.posta.sk/",
        Status: null,
      },
      {
        Country: "Slovenia",
        Company: "Pošta Slovenije",
        Website: "http://www.posta.si/",
        Status: null,
      },
      {
        Country: "Spain",
        Company: "Correos",
        Website: "http://www.correos.es/",
        Status: null,
      },
      {
        Country: "Sweden",
        Company: "PostNord",
        Website: "http://www.postnord.se/",
        Status: null,
      },
      {
        Country: "Switzerland",
        Company: "Swiss Post",
        Website: "http://www.post.ch/",
        Status: "Switzerland",
      },
      {
        Country: "Switzerland",
        Company: "Swiss Post",
        Website: "http://www.poste.ch/",
        Status: "France",
      },
      {
        Country: "Switzerland",
        Company: "Swiss Post",
        Website: "http://www.posta.ch/",
        Status: "Italy",
      },
      {
        Country: "Turkey",
        Company: "PTT (Turkey)",
        Website: "http://www.ptt.gov.tr/",
        Status: null,
      },
      {
        Country: "United Kingdom",
        Company: "Royal Mail",
        Website: "http://www.royalmail.com/",
        Status: "State-owned company",
      },
      {
        Country: "Ukraine",
        Company: "Ukrposhta",
        Website: "http://www.ukrposhta.com/",
        Status: null,
      },
      {
        Country: "Vatican City",
        Company: "Poste Vaticane",
        Website:
          "https://www.vaticanstate.va/it/servizi/direzione-telecomunicazioni/poste-e-filatelia/poste/informazioni-utili.html",
        Status: null,
      },
    ],
  },
  {
    continent: "Oceania",
    countries: [
      {
        Country: "Australia",
        Company: "Australia Post",
        Website: "https://auspost.com.au/",
        Status: "Government business enterprise",
      },
      {
        Country: "Cook Islands",
        Company: "Cook Islands Post",
        Website: "https://telecom.co.ck/",
      },
      {
        Country: "Federated States of Micronesia",
        Company: "Federated States of Micronesia Postal Service",
        Website: "https://post.gov.fm/",
      },
      {
        Country: "Fiji",
        Company: "Post Fiji",
        Website: "http://www.postfiji.com.fj/",
      },
      {
        Country: "Kiribati",
        Company: "Kiribati Public Service Public",
        Website: "http://www.pso.gov.ki/",
      },
      {
        Country: "Marshall Islands",
        Company: "Marshall Islands Post Office",
      },
      {
        Country: "Nauru",
        Company: "Nauru General Post Office",
        Website:
          "https://web.archive.org/web/20181231194240/http://www.naurugov.nr/government/departments.aspx",
      },
      {
        Country: "New Zealand",
        Company: "New Zealand Post",
        Website: "http://www.nzpost.co.nz/",
        Status: "State-owned enterprise",
      },
      {
        Country: "Palau",
        Company: "Palau Post",
        Website: "http://palaupost.pw/",
      },
      {
        Country: "Papua New Guinea",
        Company: "Post PNG",
        Website: "http://www.postpng.com.pg/",
      },
      {
        Country: "Pitcairn Islands (UK)",
        Company: "Pitcairn Islands General Post Office",
      },
      {
        Country: "Samoa",
        Company: "Samoa Post",
        Website: "http://www.samoapost.ws/",
      },
      {
        Country: "Solomon Islands",
        Company: "Solomon Post",
        Website: "http://www.solomonpost.com.sb/",
      },
      {
        Country: "Tonga",
        Company: "Tonga Post",
        Website: "http://tongapost.to/",
      },
      {
        Country: "Tuvalu",
        Company: "Tuvalu Post",
        Website: "http://tuvalupost.tv/",
      },
      {
        Country: "Vanuatu",
        Company: "Vanuatu Post",
        Website: "http://www.vanuatupost.vu/",
      },
    ],
  },
];
